import { ShowType } from '@app/models/enums/show-type.enum';
import { getEnumKeys } from '@core/utils/common.utils';

export enum StorageItem {
  Token = 'App/token',
    AuthUser = 'App/auth/user',
  SysFeats = 'App/feats',
  Subsc = 'App/subsc',
  AttrCfg = 'App/attrcfg',
  JobRes = 'App/jobres',
  Theme = 'Check/theme',
  CheckCate = 'Check/cate',
  Language = 'Check/locale',
  LastTplCfg = 'Check/lastTplCfg',
}

const LOCAL_STORAGE_KEYS: string[] = [StorageItem.Token, StorageItem.AuthUser];

export const getStorage = (itemName: StorageItem | ShowType| string): Storage => {
  if (!itemName) return sessionStorage;
  if (LOCAL_STORAGE_KEYS.includes(itemName as StorageItem)) return localStorage;
  if (itemName.startsWith('App')) return sessionStorage;
  if (itemName.startsWith('Check')) return localStorage;
  return sessionStorage;
};

export const getItem = (itemName: StorageItem | ShowType | string): unknown | null => {
  const item = getStorage(itemName).getItem(itemName);
  return item ? JSON.parse(item) : null;
};

export const setItem = (itemName: StorageItem | ShowType | string, value: unknown): void => {
  getStorage(itemName).setItem(itemName, JSON.stringify(value));
};

export const removeItem = (itemName: StorageItem | ShowType | string): void => {
  getStorage(itemName).removeItem(itemName);
};

export const cleanStorage = (): void => {
  localStorage.clear();
  sessionStorage.clear();
};

export const cleanAppStorage = (): void => {
  const storageItems = getEnumKeys(StorageItem);
  storageItems.forEach(enumKey => {
    const enumVal: any = StorageItem[enumKey];
    if (enumVal.startsWith('App') || enumVal.startsWith('action')) {
      removeItem(enumVal);
    }
  });
  cleanFilterStorage();
};

export const cleanFilterStorage = (): void => {
  const storageItems = getEnumKeys(ShowType);
  storageItems.forEach(enumKey => {
    const enumVal: any = ShowType[enumKey];
    if (enumVal.startsWith('action')) {
      removeItem(enumVal);
    }
  });
};
